import React, { ReactNode } from "react";
import Chart from 'react-apexcharts'

export interface ChartOptions {
    chart: { id: string };
    xaxis: any;
    yaxis: any;
    colors?: string[];
    dataLabels?: any;
    plotOptions?: any;
    title?: any;
}

export interface Series {
    name: string;
    data: number[] | string[];
}

export interface ChartState {
    options: ChartOptions;
    series: Series[];
    charttype: string
}



export const useApexBarChart = ({
    options,
    series,
    charttype
}: ChartState): {
    element: ReactNode;
} => {
    return {
        element: (
            // @ts-ignore
            <Chart options={options} series={series} type={charttype} width={1100} height={600} />
        ),
    };
}


export default useApexBarChart;